'use client';

import MetricLineChart from '../MetricLineChart';
import MetricGauge from '../MetricGauge';
import MetricBarChart from '../MetricBarChart';

// Sample data: Error rate trend over time
const errorRateTrendData = [
  { name: 'Week 1', errorRate: 0.85 },
  { name: 'Week 2', errorRate: 0.62 },
  { name: 'Week 3', errorRate: 0.45 },
  { name: 'Week 4', errorRate: 0.28 },
  { name: 'Week 5', errorRate: 0.15 },
  { name: 'Week 6', errorRate: 0.08 },
];

// Sample data: Error types breakdown
const errorTypesData = [
  { name: '500 Internal', count: 450, percentage: 45 },
  { name: '503 Unavailable', count: 280, percentage: 28 },
  { name: '504 Timeout', count: 150, percentage: 15 },
  { name: '400 Bad Request', count: 120, percentage: 12 },
];

// Sample data: Errors by endpoint
const errorsByEndpointData = [
  { name: '/api/reports', errors: 450, rate: 2.8 },
  { name: '/api/public/search', errors: 280, rate: 1.2 },
  { name: '/api/webhooks', errors: 150, rate: 0.8 },
  { name: '/api/users', errors: 120, rate: 0.3 },
];

export function ErrorRateTrend() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">📉 Error Rate Improvement</h3>
      <MetricLineChart
        data={errorRateTrendData}
        lines={[
          { dataKey: 'errorRate', name: 'Error Rate (%)', color: '#E89841' },
        ]}
        xAxisLabel="Week"
        yAxisLabel="Error Rate (%)"
        targetLine={0.1}
        height={350}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Sample data showing dramatic improvement from 0.85% to 0.08% error rate over 6 weeks.
        The green line represents the target threshold (0.1%). Error rate now consistently below
        target through improved error handling, input validation, and retry logic. Excellent progress.
      </p>
    </div>
  );
}

export function ErrorRateGauge() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">🎯 Current Error Rate</h3>
      <MetricGauge
        value={0.08}
        max={1}
        label="Error Rate"
        unit="%"
        ranges={[
          { min: 0, max: 25, color: '#6FCF97', label: 'Excellent' },
          { min: 25, max: 50, color: '#4A90E2', label: 'Good' },
          { min: 50, max: 75, color: '#F2C94C', label: 'Acceptable' },
          { min: 75, max: 100, color: '#EB5757', label: 'Critical' },
        ]}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        Current error rate of 0.08% is Excellent. Only 800 errors per million requests. This
        indicates robust error handling and high reliability. Continue monitoring for spikes and
        addressing root causes of remaining errors.
      </p>
    </div>
  );
}

export function ErrorTypeBreakdown() {
  return (
    <div className="my-8">
      <h3 className="text-xl font-semibold text-accent mb-4">🔍 Error Types Distribution</h3>
      <MetricBarChart
        data={errorTypesData}
        bars={[
          { dataKey: 'count', name: 'Error Count', color: '#E89841' },
        ]}
        xAxisLabel="Error Type"
        yAxisLabel="Count"
        height={300}
      />
      <p className="text-sm text-foreground-secondary mt-2">
        500 Internal Server Errors are the most common (45%), indicating server-side issues that
        need investigation. 503 Service Unavailable (28%) suggests capacity or dependency problems.
        504 Gateway Timeouts (15%) point to slow upstream services. Priority: fix root causes of
        500 errors through better error handling and testing.
      </p>
    </div>
  );
}
